import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui';

interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
}

/** Inline error panel with an optional retry action. */
export function ErrorState({ title, description, onRetry }: ErrorStateProps) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-card bg-danger-light px-6 py-10 text-center">
      <p className="font-semibold text-danger">{title ?? t('errors.unknown')}</p>
      {description && <p className="text-sm text-danger/80">{description}</p>}
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry}>
          {t('common.retry')}
        </Button>
      )}
    </div>
  );
}
